import {AbstractModel} from './abstract-model';

export class UnsubscribeProduct extends AbstractModel {
  id!: number;
  name!: string;
  identifier!: string;
}
